import {
  ATTACK_TACTIC_SUGGESTIONS,
  ATTACK_TECHNIQUE_SUGGESTIONS,
  SEARCH_FIELDS,
  SUGGESTIONS_MAP,
  TC_INDICATORS
} from "../../mappings";
import { Suggestion } from "../../@types/SearchAutosuggest";
import { FlowState } from "./@types";

export const ALL_SUGGESTIONS = SUGGESTIONS_MAP as Record<string, Suggestion>;

export const CATEGORICAL_SEARCH_DATA: { [key: string]: Suggestion[] } = {
  [SEARCH_FIELDS.ATTACK_TACTIC]: ATTACK_TACTIC_SUGGESTIONS,
  [SEARCH_FIELDS.ATTACK_TECHNIQUE]: ATTACK_TECHNIQUE_SUGGESTIONS,
  [SEARCH_FIELDS.INDICATORS]: TC_INDICATORS as unknown as Suggestion[]
};

export const FLOW_STATES: Record<FlowState, FlowState> = {
  ALL_KEYWORDS: "ALL_KEYWORDS",
  SINGLE_OR_MULTI_VALUE: "SINGLE_OR_MULTI_VALUE",
  MULTI_VALUE_OR_RANGE: "MULTI_VALUE_OR_RANGE",
  FIRST_MULTI_VALUE: "FIRST_MULTI_VALUE",
  MULTI_VALUE: "MULTI_VALUE",
  RANGETOVALUE: "RANGETOVALUE",
  CLOSE_RANGE: "CLOSE_RANGE",
  GROUP: "GROUP"
};
